import React from "react";
import Marquee from "react-fast-marquee";
import { useLang } from "../../translations";

export const ValuesMarquee = () => {
  const { t } = useLang();
  const words = t.marquee.split(" · ");
  return (
    <section data-testid="values-marquee" className="py-8 md:py-10 bg-sage border-y border-sage-dark/30 overflow-hidden">
      <Marquee speed={28} gradient={false} autoFill>
        {words.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-heading italic text-cream/95 text-2xl md:text-4xl px-12">{w}</span>
            <span className="h-1.5 w-1.5 rounded-full bg-cream/50" />
          </span>
        ))}
      </Marquee>
    </section>
  );
};
